import AdminCompany from "router/Back/AdminCompany";
import AdminWorkflowRoute from "router/Back/AdminWorkflow";
const BackRoute = [
  ...AdminCompany,
  ...AdminWorkflowRoute
];

export default BackRoute;
